module.exports = __webpack_public_path__ + "static/media/serie-c1.30ca5e5a.pdf";